import { render, staticRenderFns } from "./Fastcreatebeta.vue?vue&type=template&id=ada85876&scoped=true&"
import script from "./Fastcreatebeta.vue?vue&type=script&lang=js&"
export * from "./Fastcreatebeta.vue?vue&type=script&lang=js&"
import style0 from "./Fastcreatebeta.vue?vue&type=style&index=0&id=ada85876&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada85876",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ada85876')) {
      api.createRecord('ada85876', component.options)
    } else {
      api.reload('ada85876', component.options)
    }
    module.hot.accept("./Fastcreatebeta.vue?vue&type=template&id=ada85876&scoped=true&", function () {
      api.rerender('ada85876', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Miniprogram/Wechat/Fastcreatebeta.vue"
export default component.exports